import {
  applicationStore as applicationStoreCore,
  DefaultQueryParams,
  isMobile,
  parseQuery,
  userSettingsStore,
} from '@pascal/pascal-core';
import { resizeGame } from '../constants/resizeGame';
import { userInfoStore } from '../../store/userInfoStore';
import { soundService } from '../../services/baseSoundService';
import { registerApis } from '../../services/apiRegistration';
import { ComboKeno10, ComboKeno8, ComboKeno8GameId } from '../constants/appDefaultValues';
import { applicationStore } from '../../store/applicationStore';
import { PASCAL_PLATFORM_ID } from '../constants/pascalTestPlatformId';
import { partnerSkinEnums } from '../constants/partnerSkinEnums';

export const init = () => {
  const query = parseQuery(window.location.search);
  const {
    playerexternalid,
    currencysymbol,
    mode,
    [DefaultQueryParams.GameId]: gameId,
    [DefaultQueryParams.PartnerId]: partnerid,
    [DefaultQueryParams.RealModeSwitcher]: hasRealModeSwitcher,
    skin,
  } = query;
  if (skin) {
    applicationStore.setPartnerSkin(partnerSkinEnums[skin]);
  }
  applicationStore.setIsDemo(mode !== 'real');
  applicationStore.setHasRealModeSwitcher(hasRealModeSwitcher);
  applicationStoreCore.setIsTestPlatform(+partnerid === PASCAL_PLATFORM_ID);
  userInfoStore.setCurrencyCode(currencysymbol);
  userInfoStore.setUserId(playerexternalid);

  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
    document.documentElement.classList.remove('is-web');
  } else {
    resizeGame();
    window.addEventListener('resize', () => {
      resizeGame();
    });
    document.documentElement.classList.add('is-web');
    document.documentElement.classList.remove('is-mobile');
  }
  const gameName = +gameId === ComboKeno8GameId ? ComboKeno8 : ComboKeno10;

  userSettingsStore.localStorageAndUserSettingsInit({ gameName, soundService });
  registerApis();
};
